export enum ProfileTabEnum {
  Basic = 'Basic',
  Languages = 'Languages',
  Experience = 'Experience',
  Skill = 'Skill',
  SkillLevel = 'SkillLevel',
  Education = 'Education',
}
